import React from "react";
import classnames from "classnames";

import Button from "components/Button";
import AnimatedArrow from "components/AnimatedArrow";

import "./style.scss";

interface IProps {
  goBack?: () => void;
  showBackBtn?: boolean;
  lastStep?: boolean;
  goNext: () => void;
  disabled?: boolean;
}

const ButtonsRow = ({
  goBack,
  showBackBtn,
  lastStep,
  goNext,
  disabled = false
}: IProps) => (
  <div className={classnames("buttons-row", !showBackBtn ? "align-right" : "")}>
    {showBackBtn && (
      <Button
        onClick={goBack}
        className="back-btn"
        kind="gray"
        icon={<AnimatedArrow move="left" kind="back" />}
      >
        PREVIOUS
      </Button>
    )}
    <div>
      <Button
        kind="primary"
        className="next-btn reversed"
        onClick={goNext}
        fullWidth
        icon={<AnimatedArrow />}
        disabled={disabled}
      >
        {lastStep ? "DELIVERIES_SEND_AND_PRINT" : "NEXT_STEP"}
      </Button>
    </div>
  </div>
);

export default ButtonsRow;
